import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { BelongItemList } from '../domain/models/BelongItemList'
import { DayBelongReport } from '../domain/models/DayBelongReport'
import { NonDayBelongReport } from '../domain/models/NonDayBelongReport'
import { BelongDatasource } from '../infra/datasources/BelongDatasource'

export const belongDatasourceAdapter: BelongDatasource = {
  async updateOutgoingSetting() {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/belong-settings/outgoing`,
          httpTokenInterceptor({
            method: 'PUT'
          })
        )
      )
    )
  },
  async updateIncomingSetting() {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/belong-settings/incoming`,
          httpTokenInterceptor({
            method: 'PUT'
          })
        )
      )
    )
  },
  async updatePreparingSetting() {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/belong-settings/preparing`,
          httpTokenInterceptor({
            method: 'PUT'
          })
        )
      )
    )
  },
  async settings() {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/belong-settings`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return json
  },
  async listItem() {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/items`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return json
  },
  async createItem(data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/items`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    const json = await response.json()
    return json
  },
  async deleteItem(id) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/items/${id}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },

  async getDateBelongReport(patientId, date) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/patients/${patientId}/report-date-belongs?date=${date}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return DayBelongReport.parse(json)
  },
  async getWeekBelongReport(patientId, date) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-week-belongs?date=${date}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return NonDayBelongReport.parse(json)
  },
  async getMonthBelongReport(patientId, month, year) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-month-belongs?month=${month}&year=${year}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return NonDayBelongReport.parse(json)
  },
  async getSemesterBelongReport(patientId, year, semester) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-semester-belongs?period=${semester}&year=${year}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return NonDayBelongReport.parse(json)
  },
  async getCustomBelongReport(patientId, startDate, endDate) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/report-custom-belongs?startDate=${startDate}&endDate=${endDate}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return NonDayBelongReport.parse(json)
  },

  async getPendingList() {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/belongs-pending`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = await response.json()
    return json
  },
  async getItemsList(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/patients/${patientId}/items`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const json = BelongItemList.parse(await response.json())
    return json
  },
  async updateStatusItem(itemId, status) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/items/${itemId}`,
          httpTokenInterceptor({
            method: 'PATCH',
            body: JSON.stringify({ status }),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
  }
}
